import { Camera, CheckCircle2, Dumbbell, MessageCircle, SkipForward } from 'lucide-react'

const previewRows = [
  {
    icon: Dumbbell,
    label: 'Workout',
    title: 'Lower body today',
    detail: 'Goblet squat, split squat, hamstring curl',
  },
  {
    icon: CheckCircle2,
    label: 'Next set',
    title: 'Suggested: 45 lb x 10',
    detail: 'Based on the sets you actually logged',
  },
  {
    icon: Camera,
    label: 'Food',
    title: 'Meal photo added',
    detail: 'Your trainer can review the context without a calorie hunt',
  },
]

export function ProductPreview() {
  return (
    <div className="mx-auto w-full max-w-5xl px-6">
      <div className="relative overflow-hidden rounded-[2rem] border border-white/[0.09] bg-gradient-to-b from-soft-black/85 to-charcoal-black/90 p-4 shadow-[0_32px_90px_rgba(0,0,0,0.45)] backdrop-blur md:p-6">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-10 top-0 h-px bg-gradient-to-r from-transparent via-electric-cyan/35 to-transparent"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 right-0 w-48 bg-gradient-to-l from-electric-cyan/[0.06] to-transparent"
        />

        <div className="grid gap-4 lg:grid-cols-[1.1fr_0.9fr] lg:gap-5">
          <div className="rounded-3xl border border-white/[0.07] bg-charcoal-black/80 p-5 text-left md:p-6">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-electric-cyan">
                  Today in Boomshift
                </p>
                <h2 className="mt-2 text-[1.75rem] font-semibold tracking-tight text-soft-white md:text-3xl">
                  One place to check in and move.
                </h2>
              </div>
              <span className="rounded-full border border-forest-green/20 bg-forest-green/10 px-3 py-1 text-[11px] font-semibold tracking-[0.03em] text-forest-green">
                Invited client
              </span>
            </div>

            <div className="mt-6 space-y-3">
              {previewRows.map((row) => {
                const Icon = row.icon

                return (
                  <div
                    key={row.label}
                    className="flex gap-4 rounded-2xl border border-white/[0.06] bg-soft-black/75 p-4 transition-colors hover:border-white/[0.12]"
                  >
                    <span className="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-electric-cyan/20 bg-electric-cyan/10 text-electric-cyan">
                      <Icon size={19} aria-hidden />
                    </span>
                    <div className="min-w-0">
                      <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-silver">
                        {row.label}
                      </p>
                      <p className="mt-1 text-base font-semibold text-soft-white">{row.title}</p>
                      <p className="mt-1 text-sm leading-relaxed text-muted-silver">{row.detail}</p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          <div className="grid gap-4">
            <div className="rounded-3xl border border-white/[0.07] bg-charcoal-black/80 p-5 text-left md:p-6">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-warm-amber/20 bg-warm-amber/10 text-warm-amber">
                  <MessageCircle size={19} aria-hidden />
                </span>
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-silver">
                    Trainer note
                  </p>
                  <p className="text-sm font-medium text-soft-white">Keep the weight steady today.</p>
                </div>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-silver">
                If something feels off, leave a note on the exercise so your trainer sees it with the
                set.
              </p>
            </div>

            <div className="rounded-3xl border border-white/[0.07] bg-charcoal-black/80 p-5 text-left md:p-6">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-forest-green/20 bg-forest-green/10 text-forest-green">
                  <SkipForward size={19} aria-hidden />
                </span>
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-silver">
                    Missed today?
                  </p>
                  <p className="text-sm font-medium text-soft-white">Say why and move on.</p>
                </div>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-silver">
                Travel, illness, schedule got messy — your trainer gets the context without you
                starting over.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
